import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UuidUtil } from '@portal/util';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ParticipantModel } from '../../models/participant.model';
import { DEFAULT_CONFIG } from '@portal/data-access';

@Component({
  selector: 'portal-signing-add-recipient-dialog',
  templateUrl: './add-recipient-dialog.component.html',
  styleUrls: ['./add-recipient-dialog.component.scss'],
})
export class AddRecipientDialogComponent implements OnInit, OnDestroy {
  form: FormGroup;
  recipients: ParticipantModel[] = [];
  selectFormControl = new FormControl();
  mode: 'form' | 'selection';
  enablePhone: boolean;
  unsubscribeAll = new Subject<void>();
  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private uuidService: UuidUtil,
    private dialogRef: MatDialogRef<AddRecipientDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    private data: { item: ParticipantModel; recipients: ParticipantModel[]; enablePhone: boolean },
  ) {
    this.form = this.createForm();
    this.enablePhone = this.data?.enablePhone || false;
    if (this.enablePhone) {
      this.form.controls['phone'].setValidators(Validators.required);
      this.form.updateValueAndValidity();
    }
    if (!this.data) {
      this.mode = 'form';
      return;
    }
    this.recipients = this.data.recipients || [];
    if (this.recipients.length === 0) {
      this.mode = 'form';
    } else {
      this.mode = 'selection';
      this.selectFormControl.setValue(this.data.item || this.recipients[0]);
    }
  }
  ngOnDestroy(): void {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }

  ngOnInit(): void {
    this.selectFormControl.valueChanges.pipe(takeUntil(this.unsubscribeAll)).subscribe(res => {
      if (res === 'createNew') {
        this.mode = 'form';
      } else {
        this.form.patchValue(res);
      }
    });
  }
  // @HostListener('click', ['$event']) onClick(event) {
  //     event.preventDefault();
  //     event.stopPropagation();
  // }
  createForm(): FormGroup {
    return this.formBuilder.group({
      markupId: [''],
      email: ['', [Validators.required, Validators.email]],
      name: ['', [Validators.required, Validators.maxLength(DEFAULT_CONFIG.MAX_LENGTH.NAME_LENGTH)]],
      phone: [''],
    });
  }

  compareRecipient(option: ParticipantModel, value: ParticipantModel | 'createNew'): boolean {
    if (value === 'createNew') {
      return false;
    }
    return option.markupId === value?.markupId;
  }
  close(): void {
    this.dialogRef.close();
  }
  submit(): void {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
    this.form.controls['phone'].markAsDirty();
    if (this.mode === 'form' && this.form.invalid) {
      return;
    }
    const payload = this.getPayload();
    this.dialogRef.close(payload);
  }

  getPayload(): any {
    const dataRaw = this.mode === 'form' ? this.form.getRawValue() : this.selectFormControl.value;
    if (!dataRaw.markupId) {
      dataRaw.markupId = this.uuidService.generate();
    }
    dataRaw.phone =
      dataRaw.phone && typeof dataRaw.phone !== 'string' ? '+' + dataRaw.phone?.countryCode + dataRaw.phone?.phoneNumber : dataRaw.phone;
    return dataRaw;
  }
}
